import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { STARTERS } from "../constants";
import { Section, Button, Badge } from "@vild/site-ui";

export const StarterDetail: React.FC = () => {
  const { starterId } = useParams<{ starterId: string }>();
  const starter = starterId ? STARTERS[starterId] : undefined;

  if (!starterId) return <Navigate to="/starters" replace />;
  if (!starter) return <Navigate to="/starters" replace />;

  return (
    <Section className="pt-32">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">{starter.name}</h1>
            <p className="text-zinc-400">{starter.description}</p>
          </div>
          <Badge className="bg-zinc-800 text-zinc-400 border-zinc-700">{starter.nodes} Nodes</Badge>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8">
          <div className="text-sm text-zinc-400 mb-6">
            Starters are production-ready pipelines you can fork into your team and customize.
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button asLink={`/signup?starter=${encodeURIComponent(starter.id)}`} size="lg">
              Start with this starter
            </Button>
            <Button asLink="/starters" variant="outline" size="lg">
              Back to gallery
            </Button>
          </div>
        </div>
      </div>
    </Section>
  );
};

